import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="w-full px-4 md:px-8 py-20 flex items-center justify-center">
      <div className="max-w-lg w-full rounded-lg bg-background-50 border border-background-200 px-6 py-16 text-center">
        <span className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-50 text-primary-500">
          <i className="ri-ghost-2-line text-3xl"></i>
        </span>
        <p className="font-heading text-4xl font-bold text-primary-600 mb-2">404</p>
        <h1 className="font-heading text-xl font-bold text-foreground-950 mb-2">页面走丢啦</h1>
        <p className="text-sm text-foreground-500 mb-6">
          你访问的页面不存在或已被移除，返回首页继续浏览动漫吧。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-medium whitespace-nowrap cursor-pointer transition-colors"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/category/少年"
            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-md bg-background-100 hover:bg-background-200 text-foreground-800 font-medium whitespace-nowrap cursor-pointer transition-colors"
          >
            <i className="ri-layout-grid-line"></i>
            浏览分类
          </Link>
        </div>
      </div>
    </div>
  );
}